'use client';

import React from 'react';
import { PropsWithChildren } from 'react';

const Notifications = ({ children }: PropsWithChildren) => {
	const validChildren = React.Children.toArray(children).filter(Boolean);

	if (!validChildren.length) {
		return null;
	}

	return <div className="flex flex-col gap-2">{validChildren}</div>;
};

export default Notifications;
